<template>
  <main>
    <organism-ipam-management
      v-if="filterData && currentSubnetPage && currentIpAddressPage"
      :filter-list="filterData"
      :subnetAddressOption="subnetAddressOption"
      :subnetAddressForSidebarOption="subnetAddressForSidebarOption"
      :subnetAndIpTagsOption="subnetAndIpTagsOption"
      :totalSubnetCount="totalSubnetCount"
      :tableIpAddressFields="tableIpAddressFields"
      :tableIpAddressItems="subnetIpAddressList"
      :totalIpAddressCount="totalIpAddressCount"
      :forceSelectSubnetIdxToNull="forceSelectSubnetIdxToNull"
      :propCurrentSubnetPage="currentSubnetPage"
      :propCurrentIpAddressPage="currentIpAddressPage"
      :customerIdcIdList="customerIdcIdList"
      :siteOptions="siteOptions"
      @onUpdateFilterData="onUpdateFilterData"
      @onSetDefaultFilterData="onSetDefaultFilterData"
      @onFetchingSubnetData="onFetchingSubnetData"
      @onFetchingIpAddressData="onFetchingIpAddressData"
      @onSelectSubnetIdx="onSelectSubnetIdx"
      @onRequestAddNewSubnet="onRequestAddNewSubnet"
      @onRequestEditSubnet="onRequestEditSubnet"
      @onRequestDeleteSubnet="onRequestDeleteSubnet"
      @onRequestEditIpAddress="onRequestEditIpAddress"
      @onRequestEditMultipleIpAddress="onRequestEditMultipleIpAddress"
      @onRequestAddNewIpAddressV6="onRequestAddNewIpAddressV6"
      @onRequestDeleteIpAddress="onRequestDeleteIpAddress"
      @onRequestDeleteMultipleIpAddresses="onRequestDeleteMultipleIpAddresses"
    ></organism-ipam-management>
  </main>
</template>

<script>
import OrganismIpamManagement from "@/components/organisms/portal/internal/OrganismIpamManagement.vue"
import {
  getSubnetOptions,
  getSubnetAndIpTagList,
  getSubnetIpAddressById,
  addNewSubnet,
  editSubnet,
  overrideTagsToIp,
  deleteSubnet,
  editIpAddress,
  editMultipleIpAddress,
  addNewIpAddress,
  getContractNameList,
  getIpamSubnetsList,
  deleteIpAddress,
  deleteMultipleIpAddress,
} from "@/api/api-module1"
import mixins from "@/mixins"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import { mapActions, mapGetters } from "vuex"
import { DateTime } from "luxon"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"

export default {
  name: "IpamManagement",
  components: {
    OrganismIpamManagement,
  },
  mixins: [mixins, mixinsDatetime, mixinsObjectHelper, mixinsSiteHelper],

  data() {
    return {
      tableIpAddressFields: [
        {
          key: "isChecked",
          label: "",
        },
        {
          key: "ip",
          label: "IP ADDRESS",
          thClass: "pt-1 text-nowrap",
        },
        {
          key: "tags",
          label: "TAGS",
          thClass: "pt-1",
        },
        {
          key: "idcId",
          label: "NTDC ID/ORGANIZATION",
          thClass: "pt-1 text-nowrap",
        },
        {
          key: "ipDescription",
          label: "DESCRIPTION",
          thClass: "pt-1",
        },
        {
          key: "allocateDate",
          label: "USED DATE",
          thClass: "pt-1 text-nowrap",
        },
        {
          key: "deleteIcon",
          label: "",
          thClass: "w-50px",
          tdClass: "w-50px",
        },
      ],
      currentSubnetPage: 1,
      currentIpAddressPage: 1,
      totalSubnetCount: 0,
      totalIpAddressCount: 0,
      forceSelectSubnetIdxToNull: 0,
      selectedSubnetIdx: null,
      subnetIpAddressList: [],
      subnetAddressOption: [],
      subnetAddressForSidebarOption: [],
      subnetAndIpTagsOption: [],
      currentSubnetFilter: null,
      currentIpAddressFilter: null,
      filterData: null,

      customerIdcIdList: [],
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getInternalIpAddressManagerFilter"]),
    ...mapGetters("siteAccess", ["getSiteSelect"]),

    ...mapGetters("siteStore", ["siteSetting", "siteOptions"]),

    routeFullPath() {
      return this.$route.fullPath
    },
  },
  watch: {
    async siteSetting() {
      await this.getSubnetListForSidebarFromApi()
    },

    currentSubnetPage() {
      this.getSubnetListForSidebarFromApi(this.selectedSubnetIdx)
    },
    currentIpAddressPage() {
      this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
    },

    routeFullPath() {
      this.fetchDataFromApi()
    },
    filterData: {
      deep: true,
      handler() {
        this.currentSubnetPage = this.filterData.currentSubnetPage
        this.currentIpAddressPage = this.filterData.currentIpAddressPage
      },
    },
  },
  async mounted() {
    await this.fetchDataFromApi()
  },
  methods: {
    ...mapActions("appFilter", ["setInternalIpAddressManagerFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getInternalIpAddressManagerFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
      const targetSubnetIds = this.filterData.subnetAddress.map(
        (subnet) => subnet.subnetId
      )
      this.filterData.subnetAddress = this.subnetAddressOption.filter((item) =>
        targetSubnetIds.includes(item.subnetId)
      )
    },

    async fetchDataFromApi() {
      await this.getIdcIdListFromApi()
      await this.getSubnetOptionsFromApi()
      await this.getSubnetListForSidebarFromApi()
      await this.getSubnetAndIpTagListFromApi()
    },

    // get idc id list
    async getIdcIdListFromApi() {
      this.showLoading(true)
      this.customerIdcIdList = []
      const filter = {
        siteIds: this.siteOptions.map((site) => site.value),
        statuses: "APPROVED",
      }

      await getContractNameList(filter)
        .then((contractList) => {
          contractList.forEach((contract) => {
            this.customerIdcIdList.push({
              id: contract.contractId,
              idcId: contract.contractId.toString().padStart(8, "0"),
              name: contract.customer.customerOrganizationName,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getSubnetOptionsFromApi() {
      this.showLoading(true)
      await getSubnetOptions()
        .then((response) => {
          if (response) {
            this.subnetAddressOption = response.data
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getSubnetListForSidebarFromApi(currentSubnetIdx) {
      this.subnetAddressForSidebarOption = []

      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const filterData = this.filterSubnetDecoration()
      await getIpamSubnetsList(filterData)
        .then((response) => {
          if (response) {
            response.data.forEach((site) => {
              this.subnetAddressForSidebarOption.push({
                siteId: site.siteId,
                siteName: site.siteName,
                subnets: site.subnets.map((subnet) => ({
                  site: this.siteOptions.find(
                    (item) => item.siteId === site.siteId
                  ),
                  subnetAddress: subnet.subnetAddress,
                  subnetDescription: subnet.subnetDescription,
                  subnetId: subnet.subnetId,
                  tags: subnet.tags,
                  ipVersion: subnet.ipVersion,
                })),
              })
            })

            if (currentSubnetIdx) {
              /* Check if filtered subnet is contain current selected subnet or not, if yes it will not clear data, otherwise it will clear and user have to select subnet again */
              const isFilteredSubnetDataContainCurrentData =
                this.subnetAddressForSidebarOption.some(
                  (subnet) => subnet.subnetId === currentSubnetIdx
                )
              if (!isFilteredSubnetDataContainCurrentData) {
                this.forceSelectSubnetIdxToNull++
                this.subnetIpAddressList = []
                this.currentSubnetPage = 1
                this.currentIpAddressPage = 1
              } else {
                this.getSubnetIpAddressByIdFromApi(currentSubnetIdx)
              }
            }
          }
        })
        .finally(() => this.showLoading(false))
    },

    filterSubnetDecoration() {
      const filter = {
        PageSize: 10000,
        PageNumber: this.filterData.currentSubnetPage,
        SubnetAddresses: this.filterData.subnetAddress.length
          ? this.filterData.subnetAddress.map((item) => item.subnetAddress)
          : undefined,
        TagKeys: this.filterData.subnetTags || undefined,
        Filter: this.filterData.subnetIpAddressOrDescription || undefined,
        IdcId: this.filterData.idcId || undefined,
        IpVersion: this.filterData.ipVersion
          ? this.filterData.ipVersion.value
          : undefined,
        AllocationStartDateTime: this.filterData.isEnableAllocationDateTime
          ? this.removeTimeZone(this.filterData.allocationDateTime.start)
          : undefined,
        AllocationEndDateTime: this.filterData.isEnableAllocationDateTime
          ? this.removeTimeZone(this.filterData.allocationDateTime.end)
          : undefined,
        Statuses: this.filterData.subnetStatus.length
          ? this.filterData.subnetStatus.map((item) => item.toUpperCase())
          : undefined,
        SiteIds: this.siteOptions.map((site) => site.value),
        OrderBy: "IpVersion",
      }
      return filter
    },

    // click filter
    onUpdateFilterData(filter) {
      filter.currentSubnetPage = 1
      filter.currentIpAddressPage = 1
      if (this.routeFullPath !== "/internal/web-portal/ipam") {
        this.$router.push({ name: "ipamManagement" })
      }
      this.setInternalIpAddressManagerFilter(filter)
      this.getSubnetListForSidebarFromApi(this.selectedSubnetIdx)
    },

    onUpdateCurrentPage(filter) {
      const updatedFilter = {
        currentSubnetPage: filter.currentSubnetPage,
        currentIpAddressPage: filter.currentIpAddressPage,
        ...this.getInternalIpAddressManagerFilter,
      }
      this.setInternalIpAddressManagerFilter(updatedFilter)
      this.getSubnetListForSidebarFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        subnetAddress: [],
        subnetStatus: [],
        subnetTags: [],
        subnetIpAddressOrDescription: null,
        ipVersion: null,
        ipTags: [],
        allocationDateTime: {
          start: DateTime.now().startOf("day").toISO(),
          end: DateTime.now().toISO(),
          now: DateTime.now().toISO(),
        },
        idcId: "",
        currentSubnetPage: 1,
        totalSubnetCount: 0,
        currentIpAddressPage: 1,
        totalIpAddressCount: 0,
      }
      if (this.routeFullPath !== "/internal/web-portal/ipam") {
        this.$router.push({ name: "ipamManagement" })
      }
      this.setInternalIpAddressManagerFilter(defaultFilter)
      this.getSubnetListForSidebarFromApi()
      this.forceSelectSubnetIdxToNull++
      this.subnetIpAddressList = []
      this.currentSubnetPage = 1
      this.currentIpAddressPage = 1
    },

    onFetchingSubnetData() {
      this.getSubnetListForSidebarFromApi()
    },

    async getSubnetAndIpTagListFromApi() {
      this.showLoading(true)
      await getSubnetAndIpTagList()
        .then((response) => {
          if (response) {
            this.subnetAndIpTagsOption = response.data
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getSubnetIpAddressByIdFromApi(selectedSubnetIdx) {
      this.showLoading(true)
      const filterData = this.filterIpAddressDecoration()
      await getSubnetIpAddressById(selectedSubnetIdx, filterData)
        .then((response) => {
          if (response) {
            this.totalIpAddressCount = response.totalCount
            this.subnetIpAddressList = response.data.map((ip) => {
              return {
                ip: { ip: ip.ip, status: ip.ipStatus },
                ipDescription: ip.ipDescription,
                subnetId: ip.subnetId,
                tags: ip.tags,
                ipVersion: ip.ipVersion,
                allocationDateTime: ip.allocationDateTime,
                allocateDate: {
                  date: ip.allocationDateTime
                    ? DateTime.fromISO(ip.allocationDateTime).toFormat(
                        "dd/MM/yyyy"
                      )
                    : "",
                  time: ip.allocationDateTime
                    ? DateTime.fromISO(ip.allocationDateTime).toFormat(
                        "HH:mm:ss"
                      )
                    : "",
                },
                idcId: ip.idcId,
                isChecked: false,
              }
            })
          }
        })
        .finally(() => this.showLoading(false))
    },

    filterIpAddressDecoration() {
      const filter = {
        PageSize: 10000,
        PageNumber: this.filterData.currentSubnetPage,
        TagKeys: this.filterData.ipTags || undefined,
        Filter: this.filterData.subnetIpAddressOrDescription || undefined,
        IdcId: this.filterData.idcId || undefined,
        IpVersion: this.filterData.ipVersion
          ? this.filterData.ipVersion.value
          : undefined,
        AllocationStartDateTime: this.filterData.isEnableAllocationDateTime
          ? this.removeTimeZone(this.filterData.allocationDateTime.start)
          : undefined,
        AllocationEndDateTime: this.filterData.isEnableAllocationDateTime
          ? this.removeTimeZone(this.filterData.allocationDateTime.end)
          : undefined,
        Statuses: this.filterData.subnetStatus.length
          ? this.filterData.subnetStatus.map((item) => item.toUpperCase())
          : undefined,
      }
      return filter
    },

    onFetchingIpAddressData() {
      this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
    },

    async addNewSubnetApi(newSubnet) {
      this.showLoading(true)
      await addNewSubnet(newSubnet)
        .then((response) => {
          if (response) {
            this.toastSuccess("Added subnet successfully")
            this.fetchDataFromApi()
          } else {
            this.toastError("Add subnet failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async editSubnetApi(targetSubnetIdx, editedSubnetData) {
      this.showLoading(true)
      const { isOverrideTagsToIp, ...subnetData } = editedSubnetData
      await editSubnet(targetSubnetIdx, subnetData)
        .then((response) => {
          if (response && isOverrideTagsToIp) {
            this.overrideTagsToIpApi(targetSubnetIdx)
          } else if (response) {
            this.toastSuccess("Edited subnet successfully")
            this.fetchDataFromApi()
          } else {
            this.toastError("Edited subnet failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async overrideTagsToIpApi(subnetIdx) {
      this.showLoading(true)
      await overrideTagsToIp(subnetIdx)
        .then((response) => {
          if (response) {
            this.toastSuccess("Edited subnet successfully")
            this.fetchDataFromApi()
            this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
          } else {
            this.toastError("Edited subnet failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async deleteSubnetApi(subnetIdx) {
      this.showLoading(true)
      await deleteSubnet(subnetIdx)
        .then((response) => {
          if (response) {
            this.toastSuccess("Deleted subnet successfully")
            this.fetchDataFromApi()
            this.subnetIpAddressList = []
          } else {
            this.toastError("Delete subnet failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async editIpAddressApi(editedIpAddressData) {
      this.showLoading(true)
      const { ip, subnetId, ...ipAddressData } = editedIpAddressData
      await editIpAddress(ip, subnetId, ipAddressData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Edited Ip Address successfully")
            this.fetchDataFromApi()
            this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
          } else {
            this.toastError("Edited Ip Address failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    onUpdateCurrentSubnetPage(newSubnetPage) {
      this.currentSubnetPage = newSubnetPage
    },

    onUpdateCurrentIpAddressPage(newIpAddressPage) {
      this.currentIpAddressPage = newIpAddressPage
    },

    onSelectSubnetIdx(selectedSubnetIdx) {
      this.selectedSubnetIdx = selectedSubnetIdx
      this.getSubnetIpAddressByIdFromApi(selectedSubnetIdx)
    },

    onRequestAddNewSubnet(newSubnetData) {
      const newSubnet = {
        siteId: newSubnetData.site.value,
        subnetAddress: `${newSubnetData.subnetAddress}/${newSubnetData.subnetMask}`,
        subnetDescription: newSubnetData.subnetDescription,
        tags: newSubnetData.subnetTags,
        ipVersion: newSubnetData.type.value,
      }
      this.addNewSubnetApi(newSubnet)
    },

    onRequestEditSubnet(targetSubnetIdx, editedSubnetData) {
      this.editSubnetApi(targetSubnetIdx, editedSubnetData)
    },

    onRequestDeleteSubnet(subnetIdx) {
      this.deleteSubnetApi(subnetIdx)
    },

    onRequestEditIpAddress(editedIpAddressData) {
      this.editIpAddressApi(editedIpAddressData)
    },

    onRequestEditMultipleIpAddress(editedIpAddressesData) {
      const body = {
        ...editedIpAddressesData,
        idcId: editedIpAddressesData.idcId?.id ?? null,
      }
      this.editMultipleIpAddressApi(body)
    },

    async editMultipleIpAddressApi(editedIpAddressesData) {
      this.showLoading(true)
      const { subnetId, ...ipAddressData } = editedIpAddressesData
      await editMultipleIpAddress(subnetId, ipAddressData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Edited Ip Addresses successfully")
            this.fetchDataFromApi()
            this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
          } else {
            this.toastError("Edit Ip Addresses failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    onRequestAddNewIpAddressV6(newIpAddressData) {
      this.addNewIpAddressV6Api(newIpAddressData)
    },

    async addNewIpAddressV6Api(newIpAddressData) {
      this.showLoading(true)
      const { subnetId, ...ipAddressData } = newIpAddressData
      await addNewIpAddress(subnetId, ipAddressData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Added IPv6 successfully")
            this.fetchDataFromApi()
            this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
          }
        })
        .catch((error) => {
          this.toastError(error.response.data.ErrorMessage)
        })
        .finally(() => this.showLoading(false))
    },

    async onRequestDeleteIpAddress(targetIpData) {
      this.showLoading(true)
      await deleteIpAddress(targetIpData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Deleted Ip Address successfully")
            this.fetchDataFromApi()
            this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
          }
        })
        .catch((error) => {
          this.toastError(error.response.data.ErrorMessage)
        })
        .finally(() => this.showLoading(false))
    },

    async onRequestDeleteMultipleIpAddresses(targetIpAddresses) {
      this.showLoading(true)
      await deleteMultipleIpAddress(targetIpAddresses)
        .then((response) => {
          if (response) {
            this.toastSuccess("Deleted Ip Addresses successfully")
            this.fetchDataFromApi()
            this.getSubnetIpAddressByIdFromApi(this.selectedSubnetIdx)
          }
        })
        .catch((error) => {
          this.toastError(error.response.data.ErrorMessage)
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
